import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TEAM_SETUP_TEAM_DISPLAY_NAME', function setTeamSetupTeamDisplayName(teamDisplayName: string) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.teamDisplayName = teamDisplayName;
    }
});
